import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';
import SessionTimeoutService from '../services/SessionTimeoutService';
import { useNavigate } from 'react-router-dom';

const SessionTimeoutContext = createContext(null);

export const SessionTimeoutProvider = ({ children }) => {
    const { user, setUser } = useAuth();
    const [showWarning, setShowWarning] = useState(false);
    const navigate = useNavigate();
    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         console.log(
    //             "Remaining Time (ms):",
    //             SessionTimeoutService.getRemainingTime(),
    //             "Remaining Time (sec):",
    //             Math.floor(SessionTimeoutService.getRemainingTime() / 1000)
    //         );
    //     }, 1000);

    //     return () => clearInterval(timer);
    // }, []);
    const handleTimeout = useCallback(() => {
        setUser(null);
        // localStorage.clear();
        sessionStorage.clear();
        navigate('/logout', { replace: true });
    }, [setUser, navigate]);

    const handleWarning = useCallback(() => {
        setShowWarning(true);
    }, []);

    const extendSession = useCallback(() => {
        setShowWarning(false);
        SessionTimeoutService.reset();
    }, []);

    const logout = useCallback(() => {
        setShowWarning(false);
        SessionTimeoutService.stop();
        handleTimeout();
    }, [handleTimeout]);

    useEffect(() => {
        if (user) {
            SessionTimeoutService.setTimeoutCallbacks(handleTimeout, handleWarning);
            SessionTimeoutService.start();
        } else {
            SessionTimeoutService.stop();
        }

        return () => {
            SessionTimeoutService.stop();
        };
    }, [user, handleTimeout, handleWarning]);

    const value = {
        extendSession,
        logout,
        showWarning,
        getRemainingTime: () => SessionTimeoutService.getRemainingTime()
    };

    return (
        <SessionTimeoutContext.Provider value={value}>
            {children}
        </SessionTimeoutContext.Provider>
    );
};

export const useSessionTimeout = () => {
    const context = useContext(SessionTimeoutContext);
    if (!context) {
        throw new Error('useSessionTimeout must be used within SessionTimeoutProvider');
    }
    return context;
};
